































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import {designStore} from '@/store/store';
import {calculateFlexibleDesign} from '@/modules/design/lib/calculations/newAsphaltCalculation';
import {UnitSystem} from '@/interfaces/units';
import {IAsphaltOutputObj} from '@/modules/design/interfaces/shared';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import {getAsphaltLayers} from '@/modules/design/lib/getLayers';
import {createAsphaltValidations} from '@/modules/design/lib/validations/asphalt';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import {RoadwayClassifications} from '@/lib/data/roadwayClassification';
import {resources} from '@/lib/data/resources';
import {imperialPrecision, metricPrecision} from "@/main";
import ScenarioInformationReport from "@/modules/design/views/components/report/ScenarioInformationReport.vue";
import DesignParametersReport from "@/modules/design/views/components/report/DesignParametersReport.vue";
import AsphaltStructureReport from "@/modules/design/views/components/report/LayersReport.vue";
import LayersReport from "@/modules/design/views/components/report/LayersReport.vue";

@Component({
  components: {
    LayersReport,
    AsphaltStructureReport,
    DesignParametersReport,
    ScenarioInformationReport, ValidatedInputPageWrapper, GenericPavementDiagram, InputPageWrapper
  },
})
export default class NewAsphaltReport extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentAsphalt;
  }

  get scenarioImperial() {
    return designStore.currentAsphaltImperial;
  }


  get resultPrecision() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? imperialPrecision : metricPrecision;
  }

  validations() {
    // @ts-ignore
    return createAsphaltValidations(this.scenarioImperial);
  }

  save() {
    designStore.saveCurrentAsphaltScenario();
  }

  print() {
    window.print()
  }

  get isLightParkingLot() {
    return this.scenario.roadwayClassification === RoadwayClassifications.parkingLotLight;
  }

  get sapaResources() {
    // @ts-ignore
    return resources.states[this.scenario.state].documents;
  }

  get layers() {
    return getAsphaltLayers(designStore.currentAsphaltImperial, this.thicknessUnit, this.results);
  }

  get results(): IAsphaltOutputObj | null {
    return calculateFlexibleDesign(designStore.currentAsphaltImperial);
  }

  get thicknessUnit() {
    return this.scenario.displayUnits === UnitSystem.Imperial
        ? 'in'
        : 'cm';
  }

  get thicknessMultiplier() {
    return this.scenario.displayUnits === UnitSystem.Imperial
        ? 1
        : 2.54;
  }

}
